import React from 'react';
import PropTypes from 'prop-types';
import { SearchBox } from '@johnlewispartnership/wtr-ingredients/ingredients/SearchBox';

import SearchHistory from 'components/Search/SearchHistory';
import { useSearchForm } from 'components/Search/SearchForm/use-search-form';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from 'hooks';
import Redirect from 'components/Redirect';
import styles from './index.scss';

const SearchBar = ({ placeholder = 'Search by recipe or ingredient...' }) => {
  const location = useLocation();
  const { search, pathname } = location;

  const [searchParams] = useSearchParams();
  const searchTerm = searchParams.get('searchTerm') ?? '';

  const {
    handleBlur,
    handleChange,
    handleClear,
    handleFocus,
    handleKeyDown,
    handleSelectedSearchHistoryItem,
    handleSubmit,
    hasFocus,
    inputRef,
    insideRef,
    showSearchHistory,
    value,
  } = useSearchForm({
    autoSuggestActive: false,
    eligibleForAutoSuggest: false,
    functionalCookieConsent: true,
    initialValue: searchTerm,
    recipes: true,
    url: newSearchTerm => `/ecom/recipes/search?searchTerm=${newSearchTerm}&searchType=recipes`,
    searchType: 'recipe',
  });

  useOnClickOutside(insideRef, () => {
    handleBlur();
  });

  if (searchTerm && searchParams.get('searchType') !== 'recipes') {
    return <Redirect to={`${pathname}${search}&searchType=recipes`} replace />;
  }

  const inputProps = {
    onFocus: handleFocus,
    ref: inputRef,
  };

  return (
    <SearchBox
      ariaTitle="Recipes"
      className={styles.form}
      id="recipe-search"
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onClearClick={handleClear}
      onKeyDown={handleKeyDown}
      focus={hasFocus}
      formRef={insideRef}
      inputProps={inputProps}
    >
      {showSearchHistory && (
        <SearchHistory
          className={styles.recipesHistory}
          searchType="recipe"
          inputRef={inputRef}
          onSelectTerm={handleSelectedSearchHistoryItem}
        />
      )}
    </SearchBox>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
};

export default SearchBar;
